import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import IlluminatingFaithForTheYouth from "./sections/IlluminatingFaithForTheYouth";
import OurDigitalDna from "./sections/OurDigitalDna";
import TheLiteraryPulse from "./sections/TheLiteraryPulse";
import TalkToASpecialist from "./sections/TalkToASpecialist";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="min-h-screen bg-[#090909] text-[#f4efe5]">
      <Header />
      <main>
        <IlluminatingFaithForTheYouth />
        <OurDigitalDna />
        <TheLiteraryPulse />
        <TalkToASpecialist />
      </main>
      <Footer />
    </div>;
}